import React, { useState, useEffect, useContext } from "react";

import ShopBanner from "./ShopBanner";
import { get } from "../../util/fetch";
import { GlobalContext } from "../../globals/globalContext";

const ShopBannerController = () => {
  const [bannerText, setBannerText] = useState(null);
  const [bannerColor, setBannerColor] = useState("#c485bf");
  const [isBannerVisible, setIsBannerVisible] = useState(false);
  const { ownerlessShop } = useContext(GlobalContext);

  useEffect(() => {
    const makeApiCall = async () => {
      const response = await get(`/api/banner-text/`);
      const apiBannerText = response.banner_text_in_shop;
      const localBannerText = localStorage.getItem("bannerText");
      if (response.color_banner) {
        setBannerColor(response.color_banner);
      }

      if (!localBannerText || apiBannerText !== localBannerText) {
        setBannerText(apiBannerText);
        setIsBannerVisible(true);
      }
    };

    makeApiCall();
  }, []);

  const handleCloseBanner = () => {
    localStorage.setItem("bannerText", bannerText);
    setIsBannerVisible(false);
  };

  if (!isBannerVisible || !bannerText) return null;
  return (
    <ShopBanner
      bannerText={bannerText}
      bannerColor={bannerColor}
      isBannerVisible={isBannerVisible}
      handleCloseBanner={handleCloseBanner}
      ownerlessShop={ownerlessShop}
    />
  );
};

export default ShopBannerController;
